module.exports = __webpack_public_path__ + "static/media/7bel.67dde3d7.png";